import React from 'react';
import { FormGroup, Input, Label, FormFeedback } from 'reactstrap';
import addErrorClassName from '../helper/addErrorClassName';
import { ErrorMessage } from 'formik';
import '../../../components/FormComponents/styles.scss';

const CustomFormFeedback = ({ children }) => <FormFeedback className="styled-form-feedback">{children}</FormFeedback>;

const TextFieldFormGroup = ({
  type = 'text',
  name,
  id,
  placeholder,
  handleChange,
  handleBlur,
  values,
  errors,
  touched,
  label,
  onInput,
}) => {
  return (
    <FormGroup>
      <span className="has-float-label">
        <Input
          type={type}
          name={name}
          id={id}
          placeholder={placeholder}
          onChange={handleChange}
          onBlur={handleBlur}
          value={values[name]}
          invalid={!!errors[name] && touched[name]}
          maxLength={255}
          onInput={onInput && onInput}
        />
        <Label for={id} className={addErrorClassName(errors, touched, name)}>
          {label}
        </Label>
        <ErrorMessage name={name} component={CustomFormFeedback} />
      </span>
    </FormGroup>
  );
};

export default TextFieldFormGroup;
